import { api } from './client.js'

export const UPLOAD_CONCURRENCY = 3

export async function uploadOne({ projectId, folderId, file, relativePath, onProgress, signal }) {
  const form = new FormData()
  if (folderId) form.append('folderId', folderId)
  form.append('relativePath', relativePath || '')
  form.append('files', file, file.name)
  const { data } = await api.post(`/api/projects/${projectId}/files`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal,
    onUploadProgress: e => onProgress?.(e.total ? e.loaded / e.total : 0)
  })
  return data // { uploaded[], failed[{name, code}], createdFolders[] }
}

export async function runQueue(items, limit, fn) {
  let next = 0
  async function worker() {
    while (next < items.length) {
      const item = items[next++]
      await fn(item)
    }
  }
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker))
}
